import { render, staticRenderFns } from "./FiltersBlock.vue?vue&type=template&id=299cd9c4&scoped=true"
import script from "./FiltersBlock.vue?vue&type=script&lang=js"
export * from "./FiltersBlock.vue?vue&type=script&lang=js"
import style0 from "./FiltersBlock.vue?vue&type=style&index=0&id=299cd9c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299cd9c4",
  null
  
)

export default component.exports